"use strict";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { FLOW_CHAIN_ID } from "./mockTokenData";
export function useEisenPrices(chainId = FLOW_CHAIN_ID) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["eisenPrices", chainId],
    queryFn: async () => {
      try {
        const response = await fetch(
          `https://hiker.hetz-01.eisenfinance.com/public/v1/prices?chainId=${chainId}`,
          {
            headers: {
              "X-EISEN-KEY": process.env.REACT_APP_EISEN_API_KEY || ""
            }
          }
        );
        if (!response.ok) {
          throw new Error(`Failed to fetch prices: ${response.statusText}`);
        }
        const data2 = await response.json();
        return data2.result?.[chainId.toString()] || [];
      } catch (err) {
        console.error("Error fetching prices from Eisen API:", err);
        return [];
      }
    },
    staleTime: 30 * 1e3,
    gcTime: 2 * 60 * 1e3,
    enabled: !!chainId,
    refetchInterval: false
  });
  const pricesMap = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    const prices = data || [];
    prices.forEach((tokenPrice) => {
      map.set(tokenPrice.address.toLowerCase(), tokenPrice);
    });
    return map;
  }, [data]);
  return {
    prices: data || [],
    pricesMap,
    loading: isLoading,
    error: error ? error instanceof Error ? error.message : "Failed to fetch prices" : null,
    refetch
  };
}
